export default {
    methods: {
        isCheckIcon({ iconName, allowed }) {
          return !iconName && allowed;
        },
        isTimesIcon({ iconName, allowed }) {
          return !iconName && allowed === false;
        },
        isDynamicIcon({ iconName, allowed }) {
          return iconName && allowed;
        },
        hasIcon({ iconName, allowed }) {
          return (
              this.isCheckIcon({ iconName, allowed })
              || this.isTimesIcon({ iconName, allowed })
              || this.isDynamicIcon({ iconName, allowed })
          )
        },
    }
}